import { useEffect } from 'react';
import { PhotoCaptureCapability } from '@doxyme/extensions-bridge';
import { useAddCapability } from '@doxyme/extensions-bridge-react';
import { usePhotoCapture } from '../../usePhotoCapture';
import { bridge } from '../../../features/extensions/instances';

/**
 * Hook responsible for providing photo capture service access to the Extensions SDK
 */
export function useExtensionsPhotoCapture(): void {
  const photoCapture = useAddCapability(
    bridge,
    () => new PhotoCaptureCapability(),
  );
  const { startPhotoCapture } = usePhotoCapture();

  useEffect(() => {
    const unsubscribeFromStart = photoCapture.onStart(startPhotoCapture);

    return () => {
      unsubscribeFromStart();
    };
  }, [startPhotoCapture]);
}
